import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {Insomnia} from "@ionic-native/insomnia";

@Injectable()
export class InsomniaService {

  constructor(private insomnia: Insomnia) {

  }

  insomniaKeepAwakeScreen(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.insomnia.keepAwake()
        .then(
          () => {
            console.log('[INSOMNIA PLUGIN]', 'Success Keeping application awake');
            observer.next(true);
          }
        ).catch((error) => {
        console.log('[INSOMNIA PLUGIN]','Error Keeping application awake', error);
        observer.next(error);
      });
      ;
    });
  }

  insomniaAllowScreenSleepAgain(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.insomnia.allowSleepAgain()
        .then(
          () => {
            console.log('[INSOMNIA PLUGIN]', 'Success allowing appliccation sleep again');
            observer.next(true);
          },
        ).catch((error) => {
        console.log('[INSOMNIA PLUGIN]', 'Error allowing appliccation sleep again', error);
        observer.next(error);
      });
      ;
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/insomnia.service.ts